module.exports = {"highlight-brands":{"discover":"Discover the collection of :%brand%","explore":"Explore Now"}};